webpackJsonp([101035529556142],{

/***/ 588:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dietopro-app.54e75b37.png";

/***/ }),

/***/ 589:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dietopro-editor.1dee27d1.jpg";

/***/ }),

/***/ 590:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dietopro-eni.e2f7a4f4.jpg";

/***/ }),

/***/ 591:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dietopro-home.2f39ebe1.jpg";

/***/ }),

/***/ 592:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dietopro-miequipo.10c0afc1.jpg";

/***/ }),

/***/ 161:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _classnames = __webpack_require__(13);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Block = function Block(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    "ul",
	    { className: "c-timeline" },
	    children
	  );
	};
	
	var Item = function Item(_ref2) {
	  var left = _ref2.left,
	      right = _ref2.right,
	      big = _ref2.big;
	  return _react2.default.createElement(
	    "li",
	    { className: "c-timeline--item" },
	    left ? _react2.default.createElement(
	      "div",
	      { className: "c-timeline--item--left" },
	      _react2.default.createElement(left)
	    ) : _react2.default.createElement("div", { className: "c-timeline--item--left__empty" }),
	    _react2.default.createElement(
	      "div",
	      { className: (0, _classnames2.default)("c-timeline--spine", { "c-timeline--spine__big": big }) },
	      "ia"
	    ),
	    right ? _react2.default.createElement(
	      "div",
	      { className: "c-timeline--item--right" },
	      _react2.default.createElement(right)
	    ) : _react2.default.createElement("div", { className: "c-timeline--item--right__empty" })
	  );
	};
	
	var Text = function Text(_ref3) {
	  var title = _ref3.title,
	      children = _ref3.children;
	  return _react2.default.createElement(
	    "div",
	    { className: "c-timeline--text" },
	    _react2.default.createElement(
	      "div",
	      { className: "c-timeline--text--title h2" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "c-timeline--text--body" },
	      children
	    )
	  );
	};
	
	var Picture = function Picture(_ref4) {
	  var title = _ref4.title,
	      src = _ref4.src;
	  return _react2.default.createElement(
	    "div",
	    { className: "c-timeline--text" },
	    _react2.default.createElement(
	      "div",
	      { className: "c-timeline--text--title h2" },
	      title
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: "c-timeline--text--body" },
	      _react2.default.createElement("img", { src: src })
	    )
	  );
	};
	
	exports.default = {
	  Block: Block,
	  Item: Item,
	  Text: Text,
	  Picture: Picture
	};
	module.exports = exports["default"];

/***/ }),

/***/ 320:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Timeline = __webpack_require__(161);
	
	var _Timeline2 = _interopRequireDefault(_Timeline);
	
	var _Floodbtn = __webpack_require__(29);
	
	var _Floodbtn2 = _interopRequireDefault(_Floodbtn);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(12);
	
	var _Gradhead = __webpack_require__(145);
	
	var _Gradhead2 = _interopRequireDefault(_Gradhead);
	
	var _dietoproEditor = __webpack_require__(589);
	
	var _dietoproEditor2 = _interopRequireDefault(_dietoproEditor);
	
	var _dietoproEni = __webpack_require__(590);
	
	var _dietoproEni2 = _interopRequireDefault(_dietoproEni);
	
	var _dietoproHome = __webpack_require__(591);
	
	var _dietoproHome2 = _interopRequireDefault(_dietoproHome);
	
	var _dietoproApp = __webpack_require__(588);
	
	var _dietoproApp2 = _interopRequireDefault(_dietoproApp);
	
	var _dietoproMiequipo = __webpack_require__(592);
	
	var _dietoproMiequipo2 = _interopRequireDefault(_dietoproMiequipo);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var lefti = function lefti() {
	  return _react2.default.createElement(
	    "h1",
	    null,
	    "Hola left"
	  );
	};
	
	var text1 = function text1() {
	  return _react2.default.createElement(
	    _Timeline2.default.Text,
	    { title: "Understand your business" },
	    _react2.default.createElement(
	      "p",
	      null,
	      "We love coding. And that is precisely why we know that you must not start coding until you have a very clear idea of what is exactly needed. Every minute spent here, can be a hundred minutes saved later."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Your background makes you understand your business and believe in your business idea. We want to listen, learn, and become part of it."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "For us, ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "understanding your business"
	      ),
	      " is key."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "In ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "Dietopro"
	      ),
	      " this phase was specially important. Our client had already tested the market in a previous attempt, and there was a lot that could be learned from this previous attempt if you know how to learn from it. Analysing what had failed in order to design a better approach was the first thing that we did, together with him."
	    )
	  );
	};
	
	var pic1 = function pic1() {
	  return _react2.default.createElement(_Timeline2.default.Picture, { src: _dietoproHome2.default });
	};
	
	var text2 = function text2() {
	  return _react2.default.createElement(
	    _Timeline2.default.Text,
	    { title: "Identify the core" },
	    _react2.default.createElement(
	      "p",
	      null,
	      "Building a prototype is not easy. You need to",
	      " ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "build a proof of concept"
	      ),
	      " that captures the essence of the idea while ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "staying within a budget"
	      ),
	      ". It may sound simple, but it is not. We have all been there: there are so many cool features to implement..."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "This is the stage where the fate of your project is at stake. And you are going to hear only one thing from us:",
	      " ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "define the core of your idea and focus on it"
	      ),
	      ". There will be time (and budget) for everything else once you have proven the concept."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "In Dietopro we decided that our core was:"
	    ),
	    _react2.default.createElement(
	      "ul",
	      { className: "c-ul--text" },
	      _react2.default.createElement(
	        "li",
	        null,
	        "A very usable interview interface for dietitians to collect their patients data."
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "Artifical intelligence that could emulate the decision-making of a dietitian, providing diets ellaborated from the patient data input."
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "A reactive editor where dietitians could edit and manipulate the diets."
	      )
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "And we did it."
	    )
	  );
	};
	
	var pic2 = function pic2() {
	  return _react2.default.createElement(_Timeline2.default.Picture, { src: _dietoproEditor2.default });
	};
	
	var text3 = function text3() {
	  return _react2.default.createElement(
	    _Timeline2.default.Text,
	    { title: "Excel in the tech" },
	    _react2.default.createElement(
	      "p",
	      null,
	      "Good planning and specifications are key, but the real stuff starts right after that. The tools you choose matter, the processes you follow matter, and definitely the quality of your code matters. But these are exactly the things ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "we love to care about"
	      ),
	      "."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "In Dietopro our main efforts were focused in the key parts of the software. The AI was designed and implemented with two ideas in mind:",
	      " ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "save time to the dietitians"
	      ),
	      " and provide",
	      " ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "better diets"
	      ),
	      " than any other in the market."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "The interview and the editor were built with ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "React"
	      ),
	      ", creating a rich experience in the two interfaces where users spend a larger amount of time."
	    )
	  );
	};
	
	var pic3 = function pic3() {
	  return _react2.default.createElement(_Timeline2.default.Picture, { src: _dietoproEni2.default });
	};
	
	var text4 = function text4() {
	  return _react2.default.createElement(
	    _Timeline2.default.Text,
	    { title: "Evolve with your project" },
	    _react2.default.createElement(
	      "p",
	      null,
	      "It is not only the workload what changes through the life of a project. New technical challenges arise, better technologies appear, and you need to provide your users with cutting-edge fuctionalities."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Dietopro has ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "never stopped moving forward"
	      ),
	      " since its birth. Once the first version was published, we started building additional tools and improvements, leveraging the information provided by the users activity."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Soon enough, we were building mobile apps in ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "React Native"
	      ),
	      " ",
	      "that allowed the patients to check their diets, shopping list and evolution."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "And that was only the beginning."
	    )
	  );
	};
	
	var pic4 = function pic4() {
	  return _react2.default.createElement(_Timeline2.default.Picture, { src: _dietoproApp2.default });
	};
	
	var text5 = function text5() {
	  return _react2.default.createElement(
	    _Timeline2.default.Text,
	    { title: "Deliver at your pace" },
	    _react2.default.createElement(
	      "p",
	      null,
	      _react2.default.createElement(
	        "strong",
	        null,
	        "Projects are alive"
	      ),
	      ", just like you and me. They go through different stages, and they need different things at each of them."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "We are commited to",
	      " ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "provide exactly what you require from us"
	      ),
	      " at each step. We offer you complete flexibility. Do you need just minimun maintenance while building a user base? That's cool with us. Time to put several engineers working full time in a new module? Let's do it."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "As any other project, Dietopro has gone through all those stages. And we have gone through them working hand by hand with our client."
	    )
	  );
	};
	
	var text6 = function text6() {
	  return _react2.default.createElement(
	    _Timeline2.default.Text,
	    { title: "Grow with you" },
	    _react2.default.createElement(
	      "p",
	      null,
	      "Not every project succeeds, but some do. And yours can be one of them. When it happens is ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "beautiful"
	      ),
	      "."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "But once you are here, the hard part has already been done. Time for you to chill out and enjoy. We will take care of keeping your engines working at full speed."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "After gaining a solid user base of professional dietitians and nutrionists, Dietopro expanded creating a line addressed to gyms and sport centers: Miequipodedietistas. Our user base is growing very fast, and we are devoted to stay always one step ahead of their needs."
	    )
	  );
	};
	
	var pic6 = function pic6() {
	  return _react2.default.createElement(_Timeline2.default.Picture, { src: _dietoproMiequipo2.default });
	};
	
	var text7 = function text7() {
	  return _react2.default.createElement(
	    _Timeline2.default.Text,
	    { title: "Succeed together" },
	    _react2.default.createElement(
	      "p",
	      null,
	      "Dietopro was born in February 2016. Eighteen months later, the software is being used by more than two thousand dietitians and sport centers, providing nutritional support to more than twelve thousand patients."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "Dietopro is ",
	      _react2.default.createElement(
	        "strong",
	        null,
	        "rapidly climbing"
	      ),
	      " to the first position among the preferred softwares for proffesional nutritionists, being already chosen and supported by several proffesional colleges and associations."
	    ),
	    _react2.default.createElement(
	      "p",
	      null,
	      "After successfully launching its version for gyms and sport centers, a new line designed to provide community nutrition services in schools and elderly residencies is beign cooked. Coming soon!"
	    )
	  );
	};
	
	var CaseDietopro = function (_Component) {
	  _inherits(CaseDietopro, _Component);
	
	  function CaseDietopro() {
	    _classCallCheck(this, CaseDietopro);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  CaseDietopro.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "template c-cases" },
	      _react2.default.createElement(
	        _reactHelmet.Helmet,
	        null,
	        _react2.default.createElement("meta", {
	          name: "description",
	          content: "We work with clients of different sizes. In this case we started with a prototype and got it from zero to leader of its field."
	        }),
	        _react2.default.createElement(
	          "title",
	          null,
	          "Limenius. Case study: from prototype to success."
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "o-lettering--container o-lettering-bghl2" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "o-lettering o-lettering__ultra" },
	            "Case study:"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "o-lettering o-lettering__thin" },
	            "From prototype"
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "o-lettering o-lettering__ultra" },
	            "To success"
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: "c-trainings" },
	        _react2.default.createElement(
	          "div",
	          { className: "container" },
	          _react2.default.createElement(
	            "div",
	            { className: "o-titlehl h2 u-aligncenter" },
	            "Dietopro"
	          ),
	          _react2.default.createElement(
	            "p",
	            { className: "o-titlethin h1" },
	            "We care about your clients, evolve with your project, and adapt to your needs at each stage."
	          ),
	          _react2.default.createElement(
	            _Timeline2.default.Block,
	            null,
	            _react2.default.createElement(_Timeline2.default.Item, { left: text1, right: pic1 }),
	            _react2.default.createElement(_Timeline2.default.Item, { big: true, left: pic2, right: text2 }),
	            _react2.default.createElement(_Timeline2.default.Item, { left: text3, right: pic3 }),
	            _react2.default.createElement(_Timeline2.default.Item, { right: text5 }),
	            _react2.default.createElement(_Timeline2.default.Item, { big: true, left: text4, right: pic4 }),
	            _react2.default.createElement(_Timeline2.default.Item, { left: pic6, right: text6 }),
	            _react2.default.createElement(_Timeline2.default.Item, { left: text7 })
	          )
	        )
	      )
	    );
	  };
	
	  return CaseDietopro;
	}(_react.Component);
	
	exports.default = CaseDietopro;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-case-dietopro-js-7e068d8653bc34d29108.js